export const bottomCenterToastr: any = {
  timeOut: 3000,
  positionClass: "toast-bottom-center",
  toastClass: "toast ngx-toastr",
};
